import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/codebuild/output/src1917090841/src/company/node_modules/@nextui-org/image/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/codebuild/output/src1917090841/src/company/node_modules/@nextui-org/link/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1917090841/src/company/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1917090841/src/company/src/app/(service)/_components/AnimatedLinkButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1917090841/src/company/src/app/(service)/_components/MachiHakoSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopSection"] */ "/codebuild/output/src1917090841/src/company/src/app/(service)/_components/TopSection.tsx");
